import { useMemo } from "react";

interface SortOptions {
  sortColumn?: string;
  isSortDescending: boolean;
}

const getSortValue = (item: any, column: string): any => {
  const value = item[column];

  // Handle different data types for sorting
  if (value === null || value === undefined) return "";

  // If it's a date string, convert to timestamp
  if (typeof value === "string" && !isNaN(Date.parse(value))) {
    return new Date(value).getTime();
  }

  // If it's a string, make it lowercase for case-insensitive sorting
  if (typeof value === "string") {
    return value.toLowerCase();
  }

  // Return as-is for numbers, booleans, etc.
  return value;
};

const sortTableItems = <T>(items: T[], sortOptions: SortOptions): T[] => {
  const { sortColumn, isSortDescending } = sortOptions;

  if (!sortColumn) return items;

  return [...items].sort((a, b) => {
    const aValue = getSortValue(a, sortColumn);
    const bValue = getSortValue(b, sortColumn);

    if (aValue < bValue) return isSortDescending ? 1 : -1;
    if (aValue > bValue) return isSortDescending ? -1 : 1;
    return 0;
  });
};

export const useTableSorting = <T>(items: T[], sortOptions: SortOptions) => {
  return useMemo(() => {
    return sortTableItems(items, sortOptions);
  }, [items, sortOptions]);
};
